import lib from '@/lib';

export default class WorldMap {
	constructor() {
		
	}
	
	static Error = {
		NoSupportCanvas: new Error('NoSupportCanvas'),
	};
	
	static EventEmitter = class {
		constructor() {
			this.handlers = {};
		}
		
		addEventListener(event, callback, context = null, args = []) {
			if (typeof this.handlers[event] === 'undefined') {
				this.handlers[event] = [];
			}
			this.handlers[event].push([context, callback, args]);
			return true;
		}
		
		removeListener(event, callback) {
			if (typeof this.handlers[event] === 'undefined') {
				return false;
			}

			for (let i = 0; i < this.handlers[event].length; i++) {
				if (this.handlers[event][i][1] === callback) {
					this.handlers[event].splice(i, 1);
					return true;
				}
			}
			
			return false;
		}
		
		emit(event, localArgs = []) {
			if (typeof this.handlers[event] === 'undefined') {
				this.handlers[event] = [];
			}
			
			for (let i = 0; i < this.handlers[event].length; i++) {
				const [context = window, callback, args] = this.handlers[event][i];
				const fullArgs = [...localArgs, ...args];
				
				/*var context = this.handlers[event][i][0] || window;
				var callback = this.handlers[event][i][1];
				var args = this._cloneArguments(event, i);
				
				for (var j = localArgs.length - 1; j > -1; j--) {
					args.unshift(localArgs[j]);
				}
				//args.unshift(this);*/
				
				if (typeof callback === 'string') {
					context[callback].apply(context, fullArgs);
				} else {
					callback.apply(context, fullArgs);
				}
			}
		}
		
		_cloneArguments(event, index) {
			const result = [];
			const eventArguments = this.handlers[event][index][2];
			
			for (let i = 0; i < eventArguments.length; i++) {
				result.push(eventArguments[i]);
			}
			
			return result;
		}
	};
	
	static Mouse = class {
		constructor(element) {
			this._element = null;
			this.pressed = false;
			this.pos = { x: 0, y: 0 };
			this.diff = { x: 0, y: 0 };
			this._action = {};
			
			if (element) {
				this._watch(element);
			}
		}
		
		getAction() {
			const action = this._action;
			this._action = {};
			return action;
		}
		
		_watch(element) {
			this._element = element;
			
			document.querySelector('.map-container').addEventListener('mousemove', this._move.bind(this), true);
			this._element.addEventListener('mousedown', this._down.bind(this), true);
			document.querySelector('.map-container').addEventListener('mouseup', this._up.bind(this), true);
			document.querySelector('.map-container').addEventListener('mouseleave', this._mouseleave.bind(this), true);
			document.querySelector('.map-container').addEventListener('wheel', this._wheel.bind(this), true);
			
			this._element.addEventListener('selectstart', e => e.preventDefault(), true);
		}
		
		_destroy() {
			document.querySelector('.map-container').removeEventListener('mousemove', this._move.bind(this), true);
			document.querySelector('.map-container').removeEventListener('mouseup', this._up.bind(this), true);
			
			if (!this._element) return;
			this._element.removeEventListener('mousedown', this._down.bind(this), true);
			this._element.removeEventListener('selectstart', e => e.preventDefault(), true);
			this._element = null;
		}
		
		_move(e) {
			const x = e.offsetX ?? e.layerX;
			const y = e.offsetY ?? e.layerY;
			
			this.diff.x += Math.abs(this.pos.x - x);
			this.diff.y += Math.abs(this.pos.y - y);
			
			if (this.pressed) {
				this._addToAction('drag', this.pos.x - x, this.pos.y - y);
			} else {
				this._action.move = { x, y };
			}
			
			this.pos.x = x;
			this.pos.y = y;
		}
		
		_down(e) {
			this.pos = {
				x: e.offsetX ?? e.layerX,
				y: e.offsetY ?? e.layerY,
			};
			this.diff = { x: 0, y: 0 };
			this.pressed = true;
			this.click = true;
			
			this._showMoveCursor(true);
			this._action.down = {
				x: this.pos.x,
				y: this.pos.y,
			};
		}
		
		_up(e) {
			if (this.pressed) {
				this.pressed = false;

				this._showMoveCursor(false);
				this._action.up = {
					x: this.pos.x,
					y: this.pos.y,
				};
				
				if (this.diff.x <= 1 && this.diff.y <= 1) {
					this._action.click = {
						x: this.pos.x,
						y: this.pos.y,
					};
				}
			}
		}
		
		_mouseleave(e) {
			this._action.mouseleave = true;
		}
		
		_wheel(e) {
			if (e.deltaY > 0) {
				//console.log('Пользователь пытается прокрутить вниз');
				this._action.scroll = 'down';
			} else if (e.deltaY < 0) {
				//console.log('Пользователь пытается прокрутить вверх');
				this._action.scroll = 'up';
			}
		}
		
		_addToAction(key, x, y) {
			if (!this._action[key]) {
				this._action[key] = { x: 0, y: 0 };
			}
			
			this._action[key].x += x;
			this._action[key].y += y;
		}
		
		_showMoveCursor(active) {
			const el = document.querySelector('.map-container');
			if (!el) return;
			
			if (active) {
				/*if (lib.browser == 'mozilla') {
					el.style.cursor = '-moz-grabbing !important';
				} else if (lib.browser == 'msie') {
					el.style.cursor = 'url(img/cursor/closedhand.cur), move';
				} else {
					el.style.cursor = 'url(img/cursor/closedhand.cur) 4 4, move';
				}*/
				el.style.cursor = 'move';
			} else {
				el.style.cursor = 'pointer';
			}
		}
	};
	
	static Canvas = class {
		constructor(width, height, core) {
			this.width = width;
			this.height = height;
			this.core = core;
			this.canvas = [];
			this.requestAnimationFrameId = null;
			
			const list = [
				{ width, height },
				{ width: width * 2, height: height * 2 },
				{ width: width * 2, height: height * 2 },
				{ width: width * 2, height: height * 2 }
			];
			
			list.forEach(v => {
				const tmp = this._createCanvas(v.width, v.height);
				if (tmp) this.canvas.push(tmp);
			});
			
			if (this.canvas.length !== list.length) {
				throw WorldMap.Error.NoSupportCanvas;
			}
			
			document.querySelector('.map-container').appendChild(this.canvas[0].canvas);
			this._mouse = new WorldMap.Mouse(this.canvas[0].canvas);
		}
		
		render() {
			this.requestAnimationFrameId = requestAnimationFrame(this.render.bind(this));
			const pos = this.core._render(this.canvas[1].ctx, this.canvas[2].ctx, this._mouse);
			
			this.canvas[0].ctx.clearRect(0, 0, this.width, this.height);
			this.canvas[0].ctx.drawImage(this.canvas[1].canvas, -pos.x, -pos.y);
			this.canvas[0].ctx.drawImage(this.canvas[2].canvas, -pos.x, -pos.y);
		}
		
		destroy() {
			cancelAnimationFrame(this.requestAnimationFrameId);
			const container = document.querySelector('.map-container');
			if (container.firstChild) container.firstChild.remove();
			this._mouse._destroy();
		}
		
		clearBuffer() {
			this.canvas[1].ctx.clearRect(0, 0, this.width * 2, this.height * 2);
		}
		
		clearBuffer2() {
			this.canvas[2].ctx.clearRect(0, 0, this.width * 2, this.height * 2);
		}
		
		_createCanvas(width, height) {
			const canvas = document.createElement('canvas');
			canvas.width = width;
			canvas.height = height;
			
			const ctx = canvas.getContext('2d');
			if (!ctx) {
				document.body.innerHTML = '<div style="text-align: center;">No support 2d context.</div>';
				return null;
			}
			
			ctx.font = '16px monospace';
			ctx.textAlign = 'center';
			return { canvas, ctx };
		}
	};
	
	static Cell = class {
		static _marker_params = {
			topleft: {
				size: 5,
				offset: 5,
				color: '#fff',
				strokeWidth: 1,
				visible: false,
			},
		};
		static _marks_params = {
			selected: {
				color: '#fff',
			},
			ownIsland: {
				color: '#fc0',
			},
			yourUnion: {
				color: '#44f',
			},
			abandonedIsland: {
				color: '#999',
			},
			miscellaneous: {
				color: '#820',
			},
			ally: {
				color: '#0af',
			},
			nap: { //nonAgressionPact
				color: '#c0c',
			},
			enemy: {
				color: '#f00',
			},
		};
		
		constructor(type = 'empty', image, x, y, data = {}, cell, params = {}) {
			this.image = image || WorldMap.Core._img_prefix + WorldMap.Core._img_types.empty;
			this.type = type;
			this.mark = params?.mark || 'empty';
			this.marker = {
				topleft: {
					size: params?.marker?.topleft?.size ?? WorldMap.Cell._marker_params.topleft.size,
					offset: params?.marker?.topleft?.offset ?? WorldMap.Cell._marker_params.topleft.offset,
					color: params?.marker?.topleft?.color ?? WorldMap.Cell._marks_params[params?.mark]?.color ?? WorldMap.Cell._marker_params.topleft.color,
					strokeWidth: params?.marker?.topleft?.strokeWidth ?? WorldMap.Cell._marker_params.topleft.strokeWidth,
					visible: params?.marker?.topleft?.visible ?? WorldMap.Cell._marker_params.topleft.visible,
				},
			};
			this.data = data;
			this._params = params;
			this.x = x;
			this.y = y;
			this.width = cell.width;
			this.height = cell.height;
			this.pos = {
				x: x * cell.width,
				y: y * cell.height,
			};
		}
		
		resize(width, height) {
			this.width = width;
			this.height = height;
			this.pos = {
				x: this.x * width,
				y: this.y * height,
			};
		}
		
		/**
		 * Изменение данных маркера ячейки
		 * @param {Object} marker 
		 */
		changeMarker(marker) {
			this.marker = lib.deepMerge({
				topleft: {
					size: this._params.marker?.topleft?.size ?? WorldMap.Cell._marker_params.topleft.size,
					offset: this._params.marker?.topleft?.offset ?? WorldMap.Cell._marker_params.topleft.offset,
					color: this._params.marker?.topleft?.color ?? WorldMap.Cell._marks_params[this._params?.mark]?.color ?? WorldMap.Cell._marker_params.topleft.color,
					strokeWidth: this._params.marker?.topleft?.strokeWidth ?? WorldMap.Cell._marker_params.topleft.strokeWidth,
					visible: this._params.marker?.topleft?.visible ?? WorldMap.Cell._marker_params.topleft.visible,
				},
			}, marker || {} );
		}
		
		/**
		 * Отрисовка содержимого ячейки
		 * @param {*} ctx 
		 * @param {Number} x 
		 * @param {Number} y 
		 */
		draw(ctx, x, y) {
			const img = WorldMap.Resources.get(this.image);
			if (img) {
				ctx.drawImage(img, this.pos.x - x, this.pos.y - y, this.width, this.height);
			}

			const mtl = this.marker.topleft;
			if (mtl.visible) {
				ctx.beginPath();
				ctx.arc(
					this.pos.x - x + mtl.size + mtl.offset,
					this.pos.y - y + mtl.size + mtl.offset,
					mtl.size,
					0,
					2 * Math.PI
				);
				ctx.fillStyle = mtl.color;
				ctx.fill();
				if (mtl.strokeWidth > 0) {
					ctx.lineWidth = mtl.strokeWidth;
					ctx.strokeStyle = '#1c1300';
					ctx.stroke();
				}
			}
		}
		
		/**
		 * Получение позиции ячейки
		 * @returns {Object}
		 */
		getPos() {
			return this.pos;
		}
		
		/**
		 * Отрисовка фокуса на ячейке
		 * @param {*} ctx 
		 * @param {Number} x 
		 * @param {Number} y 
		 */
		focus(ctx, x, y) {
			ctx.beginPath();
			
			/*ctx.ellipse(
				this.pos.x - x - this.width / 2,
				this.pos.y - y - this.height / 2,
				this.width / 2,
				this.height / 2,
				0,
				0,
				2 * Math.PI,
				false
			);*/
			
			// top-left
			ctx.moveTo(this.pos.x - x - this.width, this.pos.y - y - this.height);
			ctx.lineTo(this.pos.x - x - (this.width - 10), this.pos.y - y - this.height);
			ctx.moveTo(this.pos.x - x - this.width, this.pos.y - y - this.height);
			ctx.lineTo(this.pos.x - x - this.width, this.pos.y - y - (this.height - 10));
			
			// top-right
			ctx.moveTo(this.pos.x - x, this.pos.y - y - this.height);
			ctx.lineTo(this.pos.x - x - 10, this.pos.y - y - this.height);
			ctx.moveTo(this.pos.x - x, this.pos.y - y - this.height);
			ctx.lineTo(this.pos.x - x, this.pos.y - y - (this.height - 10));
			
			// bottom-left
			ctx.moveTo(this.pos.x - x - this.width, this.pos.y - y);
			ctx.lineTo(this.pos.x - x - (this.width - 10), this.pos.y - y);
			ctx.moveTo(this.pos.x - x - this.width, this.pos.y - y);
			ctx.lineTo(this.pos.x - x - this.width, this.pos.y - y - 10);
			
			// bottom-right
			ctx.moveTo(this.pos.x - x, this.pos.y - y);
			ctx.lineTo(this.pos.x - x - 10, this.pos.y - y);
			ctx.moveTo(this.pos.x - x, this.pos.y - y);
			ctx.lineTo(this.pos.x - x, this.pos.y - y - 10);
			
			ctx.lineWidth = 2;
			ctx.strokeStyle = '#ff0';
			ctx.stroke();
		}
		
		/**
		 * Отрисовка выбора ячейки
		 * @param {*} ctx 
		 * @param {Number} x 
		 * @param {Number} y 
		 */
		select(ctx, x, y) {
			ctx.beginPath();
			
			/*ctx.ellipse(
				this.pos.x - x - this.width / 2,
				this.pos.y - y - this.height / 2,
				this.width / 2,
				this.height / 2,
				0,
				0,
				2 * Math.PI,
				false
			);*/
			
			// top-left
			ctx.moveTo(this.pos.x - x - this.width, this.pos.y - y - this.height);
			ctx.lineTo(this.pos.x - x - (this.width - 10), this.pos.y - y - this.height);
			ctx.moveTo(this.pos.x - x - this.width, this.pos.y - y - this.height);
			ctx.lineTo(this.pos.x - x - this.width, this.pos.y - y - (this.height - 10));
			
			// top-right
			ctx.moveTo(this.pos.x - x, this.pos.y - y - this.height);
			ctx.lineTo(this.pos.x - x - 10, this.pos.y - y - this.height);
			ctx.moveTo(this.pos.x - x, this.pos.y - y - this.height);
			ctx.lineTo(this.pos.x - x, this.pos.y - y - (this.height - 10));
			
			// bottom-left
			ctx.moveTo(this.pos.x - x - this.width, this.pos.y - y);
			ctx.lineTo(this.pos.x - x - (this.width - 10), this.pos.y - y);
			ctx.moveTo(this.pos.x - x - this.width, this.pos.y - y);
			ctx.lineTo(this.pos.x - x - this.width, this.pos.y - y - 10);
			
			// bottom-right
			ctx.moveTo(this.pos.x - x, this.pos.y - y);
			ctx.lineTo(this.pos.x - x - 10, this.pos.y - y);
			ctx.moveTo(this.pos.x - x, this.pos.y - y);
			ctx.lineTo(this.pos.x - x, this.pos.y - y - 10);
			
			ctx.lineWidth = 2;
			ctx.strokeStyle = '#fff';
			ctx.stroke();
		}
	};
	
	static Core = class extends WorldMap.EventEmitter {
		static _getmap_api_url = '/api/mapdata';
		static _img_prefix = 'https://iwstatic.g.bsrv.su/img/map_v2/';
		static _img_types = {
			empty: 'sea_empty.png',
			free: 'sea_free.png',
			cloud: 'cloud1.png',
			cloud1: 'cloud1.png',
			cloud2: 'cloud2.png',
			cloud3: 'cloud3.png',
			cloud4: 'cloud4.png',
			island1: 'v2/island1.png',
			island1_left: 'v2/island1_left.png',
			bonus1: 'v2/bonus1.png',
			bonus1_left: 'v2/bonus1_left.png',
		};
		
		constructor(width, height, center_x, center_y, region_width = 128, region_height = 128, params = {}) {
			super();
			
			this._options = {
				size: { width, height },
				cell: {
					width: region_width,
					height: region_height,
					
					cols: Math.ceil(width / region_width) + 8, // Количество колонок
					rows: Math.ceil(height / region_height) + 8, // Количество рядов
				},
				focused: null,
				selected: null,
				deselectable: params?.deselectable ?? true,
			};
			this._img_prefix = params?.img_prefix ?? WorldMap.Core._img_prefix;
			this._img_types = { ...WorldMap.Core._img_types, ...params?.img_types };
			this._cellMarker = params?.cellMarker || {};
			this._getmap_api_url = params?.getmap_api_url || WorldMap.Core._getmap_api_url;
			this._rebuild_buffer = false;
			this._rebuild_buffer2 = false;
			
			this._data = {}; // Тут хранится загруженная карта
			
			this.init(center_x, center_y);
		}
		
		/**
		 * Инициализация карты
		 * @param {Number} center_x 
		 * @param {Number} center_y 
		 * @returns 
		 */
		init(center_x = 0, center_y = 0) {
			try {
				this._canvas = new WorldMap.Canvas(this._options.size.width, this._options.size.height, this);
			} catch (e) {
				if (e !== WorldMap.Error.NoSupportCanvas) throw e;
				return;
			}
			
			this._rebuild_buffer = true; // Флаг о том, что нужно перестроить буфер
			this._rebuild_buffer2 = true; // Флаг о том, что нужно перестроить буфер 2
			
			let count = 1;
			const _afterAll = () => {
				if (--count === 0) {
					//console.log('init complete over ' + (new Date() - initRunTime) + 'ms');
					
					// Запускаем рендеринг
					this._canvas.render();
				}
			};
			
			count++;
			if (!WorldMap.Resources.has(this._img_prefix + this._img_types.empty)) {
				WorldMap.Resources.add(this._img_prefix + this._img_types.empty);
			}
			_afterAll();
			
			this.goto(center_x, center_y, false, _afterAll);
		}
		
		/**
		 * Изменение размеров карты
		 * @param {Number} width Ширина
		 * @param {Number} height Высота
		 * @param {Function} callback функция обратного вызова
		 */
		resize(width, height, callback) {
			//console.log('resize');
			
			this._options.size.width = width;
			this._options.size.height = height;
			this._options.cell.cols = Math.ceil(width / this._options.cell.width) + 8;
			this._options.cell.rows = Math.ceil(height / this._options.cell.height) + 8;
			
			this._canvas.destroy();
			this.init(this._options.selected?.x, this._options.selected?.y);
			callback?.();
		}
		
		/**
		 * Изменение размеров ячеек карты
		 * @param {Number} width Ширина
		 * @param {Number} height Высота
		 * @param {Function} callback функция обратного вызова
		 */
		resizeCells(width, height, callback) {
			//console.log('resizeCells');
			
			this._options.cell.width = width;
			this._options.cell.height = height;
			this._options.cell.cols = Math.ceil(this._options.size.width / width) + 8;
			this._options.cell.rows = Math.ceil(this._options.size.height / height) + 8;
			for (const x in this._data) {
				for (const y in this._data[x]) {
					const cell = this._data[x][y];
					cell?.resize(width, height);
				}
			}
			
			this._canvas.destroy();
			this.init(this._options.selected?.x, this._options.selected?.y);
			callback?.();
		}
		
		/**
		 * Изменить данные маркера во всех ячейках
		 * @param {Object} marker данные маркера
		 * @param {Function} callback функция обратного вызова
		 */
		changeCellsMarker(marker, callback) {
			for (const x in this._data) {
				for (const y in this._data[x]) {
					const cell = this._data[x][y];
					cell?.changeMarker(marker);
				}
			}
			
			this._rebuild_buffer = true;
			callback?.();
		}
		
		/**
		 * Изменить данные маркера в указанной ячейке
		 * @param {Number} x 
		 * @param {Number} y 
		 * @param {Object} marker 
		 * @param {Function} callback функция обратного вызова
		 */
		changeCellMarker(x, y, marker, callback) {
			const cell = this._data[x][y];
			cell?.changeMarker(marker);
			
			this._rebuild_buffer = true;
			callback?.();
		}
		
		/**
		 * Изменение типов изображений
		 * @param {Object} img_types 
		 * @param {Function} callback функция обратного вызова
		 */
		changeImgTypes(img_types = {}, callback) {
			//console.log('changeImgTypes');
			this._img_types = { ...WorldMap.Core._img_types, ...img_types };
			
			this._canvas.destroy();
			this.init(this._options.selected?.x, this._options.selected?.y);
			callback?.();
		}
		
		/**
		 * Изменение префикса для изображений
		 * @param {String} img_prefix 
		 * @param {Function} callback функция обратного вызова
		 */
		changeImgPrefix(img_prefix = WorldMap.Core._img_prefix, callback) {
			//console.log('changeImgTypes');
			this._img_prefix = img_prefix;
			
			this._canvas.destroy();
			this.init(this._options.selected?.x, this._options.selected?.y);
			callback?.();
		}
		
		/**
		 * Уничтожение модели карты
		 */
		destroy() {
			this._canvas.destroy();
		}
		
		/**
		 * Переход к указанным координатам
		 * @param {Number} center_x 
		 * @param {Number} center_y 
		 * @param {Boolean} select Выделить ячейку после перехода к ней
		 * @param {Function} callback функция обратного вызова
		 */
		goto(center_x = 0, center_y = 0, select = false, callback) {
			// Получаем из координат центра координаты углов нужной области
			const cols = this._options.cell.cols;
			const rows = this._options.cell.rows;
			const coords = {
				x1: center_x - Math.ceil(cols / 2),
				y1: center_y - Math.ceil(rows / 2),
				x2: center_x - Math.ceil(cols / 2) + cols,
				y2: center_y - Math.ceil(rows / 2) + rows,
			};
			
			if (select && this._checkHasData(center_x, center_y)) {
				this._options.selected = {
					x: center_x,
					y: center_y,
				};
			}
			
			this._options.pos = {
				//  Пиксельные координаты верхнего левого угла канваса!
				px: {
					x: (coords.x1 + 4) * this._options.cell.width,
					y: (coords.y1 + 4) * this._options.cell.height
				},
				
				// Смещение буффера
				offset: {
					x: this._options.cell.width * 4,
					y: this._options.cell.height * 4
				},
				
				// Координаты
				coord: {
					x: coords.x1,
					y: coords.y1,
				},
			};
			
			this._load_map(coords, () => {
				callback?.();
				if (this._options.selected) {
					this.emit('select', [this._options.selected]);
				}
			});
		}
		
		/**
		 * Выделение ячейки карты
		 * @param {Number} x 
		 * @param {Number} y 
		 */
		select(x, y) {
			if (this._checkHasData(x, y)) {
				this._options.selected = { x, y };
				this.emit('select', [this._options.selected]);
				this._rebuild_buffer2 = true;
			}
		}
		
		/**
		 * Снятие выделения с ячейки карты
		 */
		deselect() {
			const sel = this._options.selected;
			this._options.selected = null;
			this.emit('deselect', [sel]);
			this._rebuild_buffer2 = true;
		}
		
		/**
		 * Получение ячейки карты
		 * @param {Number} x координата X
		 * @param {Number} y координата Y
		 * @returns {WorldMap.Cell|null} возвращает ячейку карты или null, если ячейка не существует
		 */
		getCell(x, y) {
			return this._data[x]?.[y] || null;
		}
		
		/**
		 * Перезагрузка ячейки карты
		 * @param {Number} x координата X
		 * @param {Number} y координата Y
		 * @param {Function} callback функция обратного вызова
		 */
		reloadCell(x, y, callback) {
			delete this._data[x][y];
			this._load_map({ x1: x, y1: y, x2: x, y2: y }, callback);
		}
		
		/**
		 * Получение данных карты через AJAX
		 * @param {Object} coords 
		 * @param {Function} callback функция обратного вызова
		 * @returns 
		 */
		async _get_ajax_map(coords, callback) {
			//console.log(coords);
			const { x1, x2, y1, y2 } = coords;
			if ([x1, x2, y1, y2].some(v => v == null)) {
				callback?.({});
				return;
			}
			try {
				const response = await axios.get(this._getmap_api_url, {
					params: coords,
					mode: 'cors',
					cache: 'no-cache',
					withCredentials: true,
				});
				callback?.(response.data.map);
			} catch (err) {
				console.error(err);
			}
			
			/*setTimeout(() => {
				// Генегируем ответ аякса
				let map = {};
				for(let x = Math.min(coords.x1, coords.x2); x <= Math.max(coords.x1, coords.x2); x++) {
					for(let y = Math.min(coords.y1, coords.y2); y <= Math.max(coords.y1, coords.y2); y++) {
						if (typeof map[x] == 'undefined') {
							map[x] = {};
						}
						
						if (x < -6 || y < -6
						|| x > 6 || y > 6) {
							// пустота (море, пустыня, космос, на ваше усмотрение)
							map[x][y] = {
								type: 'empty',
								//image: null,
								data: {},
							};
						} else {
							//map[x][y] = {
							//	type: 'item',
							//	image: 'https://iwstatic.g.bsrv.su/img/map_v2/' + (((Math.abs(y) * 200 + Math.abs(x)) % 7 + 2) + '.png'),
							//	data: {},
							//};
							//map[x][y] = {
							//	type: 'item',
							//	image: WorldMap.Core._img_prefix + WorldMap.Core._img_types.island1,
							//	data: {},
							//};
							
							//let imgs = ['v2/island1', 'v2/island1_left', 'v2/bonus1', 'v2/bonus1_left', 'cloud1'];
							let types = ['cloud', 'island1', 'island1_left', 'bonus1', 'bonus1_left'];
							map[x][y] = {
								//type: 'item',
								type: types[lib.mt_rand(0, types.length - 1)],
								//image: 'https://iwstatic.g.bsrv.su/img/map_v2/'+imgs[lib.mt_rand(0, imgs.length - 1)]+'.png',
								data: {},
							};
						}
					}
				}
				
				callback?.(map);
			}, 0);*/
		}
		
		/**
		 * Проверка наличия данных в ячейке
		 * @param {Object} coords 
		 * @param {Function} callback функция обратного вызова
		 */
		_load_map(coords, callback) {
			// отсеивание загруженных ячеек (хотя бы немного)
			const tcoords = { x: [], y: [] };
			for (let x = Math.min(coords.x1, coords.x2); x <= Math.max(coords.x1, coords.x2); x++) {
				for (let y = Math.min(coords.y1, coords.y2); y <= Math.max(coords.y1, coords.y2); y++) {
					if (!this._data[x]?.[y]) {
						tcoords.x.push(x);
						tcoords.y.push(y);
						//console.log(x, y);
					}
				}
			}
			
			const coords2 = {
				x1: tcoords.x.length ? Math.min(...tcoords.x) : null,
				x2: tcoords.x.length ? Math.max(...tcoords.x) : null,
				y1: tcoords.y.length ? Math.min(...tcoords.y) : null,
				y2: tcoords.y.length ? Math.max(...tcoords.y) : null,
			};
			//console.log('coords', 'x:', coords.x1, '-', coords.x2, 'y:', coords.y1, '-', coords.y2);
			//console.log('coords2', 'x:', coords2.x1, '-', coords2.x2, 'y:', coords2.y1, '-', coords2.y2);
			
			this._get_ajax_map(coords2, map => {
				const imgs = {};
				
				for (const [x, row] of Object.entries(map)) {
					for (const [y, data] of Object.entries(row)) {
						//console.log(data);
						if (!this._data[x]) this._data[x] = {};
						if (!this._data[x][y]) {
							let type = 'empty', img = null;
							if (data) {
								type = data.clouded ? 'cloud' : data.idIsland && data.idUser ? 'island1' : data.idIsland ? 'island1_left' : 'free';
								img = this._img_prefix + this._img_types[type];
								if (!WorldMap.Resources.has(img)) {
									imgs[img] = img;
								}
							}
							const marker = lib.deepMerge(structuredClone(this._cellMarker), {
								topleft: {
									visible: (this._cellMarker?.topleft?.show || ['selected', 'ownIsland', 'yourUnion', 'miscellaneous', 'ally', 'nap', 'enemy']).includes(data?.mark || 'empty'),
								},
							});
							this._data[x][y] = new WorldMap.Cell(type, img, +x, +y, data || {}, this._options.cell, {
								mark: data?.mark,
								marker,
							});
							/*if (data.type == 'empty') {
								// Якобы космос
								//this._data[x][y] = null;
								this._data[x][y] = new WorldMap.Cell(
									'empty',
									data.image,
									x, y,
									{},
									this._options.cell
								)
							} else {
								if (!WorldMap.Resources.has(data.image)) {
									imgs[data.image] = data.image;
								}
								
								this._data[x][y] = new WorldMap.Cell(
									data.type,
									data.image,
									x, y,
									data.data,
									this._options.cell
								);
							}*/
						}
					}
				}
				
				// Загружаем картинки
				WorldMap.Resources.add(imgs, () => this._rebuild_buffer = true);
				this._rebuild_buffer = true;
				callback?.(coords);
			});
		}
		
		/**
		 * Перестроение всех буферов
		 * @param {CanvasRenderingContext2D} buffer 
		 */
		_rebuildBuffer(buffer) {
			const { cell, pos } = this._options;
			const left = pos.coord.x * cell.width + cell.width;
			const top = pos.coord.y * cell.height + cell.height;
			
			// Находим отображаемый диапазон
			this._canvas.clearBuffer();
			
			for (let x = pos.coord.x; x <= pos.coord.x + cell.cols; x++) {
				for (let y = pos.coord.y; y <= pos.coord.y + cell.rows; y++) {
					const cellObj = this._data[x]?.[y];
					cellObj?.draw(buffer, left, top);
				}
			}
		}
		
		/**
		 * Перестроение буфера 2
		 * @param {CanvasRenderingContext2D} buffer 
		 */
		_rebuildBuffer2(buffer) {
			this._canvas.clearBuffer2();
			
			const left = this._options.pos.coord.x * this._options.cell.width;
			const top = this._options.pos.coord.y * this._options.cell.height;
			
			const sel = this._options.selected;
			const foc = this._options.focused;
			
			if (sel) this._data[sel.x]?.[sel.y]?.select(buffer, left, top);
			if (foc) this._data[foc.x]?.[foc.y]?.focus(buffer, left, top);
		}
		
		/**
		 * Получение координат ячейки по пикселям
		 * @param {Number} px_x координата X в пикселях
		 * @param {Number} px_y координата Y в пикселях
		 * @param {Boolean} need4
		 * @returns {Object} возвращает объект с координатами ячейки
		 */
		_getXYByPx(px_x, px_y, need4) {
			const x = Math.floor(px_x / this._options.cell.width);
			const y = Math.floor(px_y / this._options.cell.height);
			return need4 ? { x: x - 4, y: y - 4 } : { x, y };
		}
		
		/**
		 * Получение координат ячейки по пикселям
		 * @param {Number} x координата X
		 * @param {Number} y координата Y
		 * @param {Boolean} need4
		 * @returns {Object} возвращает объект с координатами ячейки
		 */
		_getXYByScreenPx(x, y, need4 = false) {
			const p = this._options.pos.px;
			return this._getXYByPx(x + this._options.cell.width + p.x, y + this._options.cell.height + p.y, need4);
		}
		
		/**
		 * Проверка наличия данных в ячейке карты
		 * @param {Number} x координата X
		 * @param {Number} y координата Y
		 * @returns {boolean} возвращает true, если данные существуют, иначе false
		 */
		_checkHasData(x, y) {
			return this._data[x]?.[y]?.type !== 'empty';
		}
		
		/**
		 * Проверка перемещения карты
		 * @param {Mouse} mouse
		 */
		_checkMoveMap(mouse) {
			const act = mouse.getAction();
			if (act.click) {
				const sel = this._getXYByScreenPx(act.click.x, act.click.y);
				this.emit('click', [act.click]);
				if (this._checkHasData(sel.x, sel.y)) {
					if(this._options.deselectable && this._options.selected?.x === sel.x && this._options.selected?.y === sel.y) {
						const sel = this._options.selected;
						this._options.selected = null;
						this.emit('deselect', [sel]);
					} else {
						this._options.selected = sel;
						this.emit('select', [sel]);
					}
					this._rebuild_buffer2 = true;
				}
			}
			if (act.move) {
				const foc = this._getXYByScreenPx(act.move.x, act.move.y);
				this._options.focused = this._checkHasData(foc.x, foc.y) ? foc : null;
				this._rebuild_buffer2 = true;
				this.emit('focus', [this._options.focused]);
			}
			if (act.drag) {
				const p = this._options.pos;
				p.offset.x += act.drag.x;
				p.offset.y += act.drag.y;
				p.px.x += act.drag.x;
				p.px.y += act.drag.y;
				
				const w = this._options.cell.width, h = this._options.cell.height;
				const { offset } = p;
				
				const shouldReload = offset.x <= w * 2 || offset.x >= w * 6 || offset.y <= h * 2 || offset.y >= h * 6;
				if (shouldReload) {
					const xy = this._getXYByPx(p.px.x, p.px.y, true);
					p.coord = xy;
					p.offset.x = w * 4 + (p.px.x - (xy.x + 4) * w);
					p.offset.y = h * 4 + (p.px.y - (xy.y + 4) * h);
					
					const way_x = offset.x <= w * 2 ? -1 : offset.x >= w * 6 ? 1 : 0;
					const way_y = offset.y <= h * 2 ? -1 : offset.y >= h * 6 ? 1 : 0;
					this._rebuild_buffer = true;
					this._checkNeedLoadMap(xy.x, xy.y, way_x, way_y);
				}
				this.emit('drag', []);
			}
			if (act.scroll) {
				this.emit('scroll', [act.scroll]);
			}
			if (act.mouseleave) {
				this._options.focused = null;
				this._rebuild_buffer2 = true;
				this.emit('mouseleave', []);
			}
		}
		
		/**
		 * Проверка необходимости загрузки карты
		 * @param {Number} xx
		 * @param {Number} yy
		 * @param {Number} way_x
		 * @param {Number} way_y
		 * @returns {Boolean}
		 */
		_checkNeedLoadMap(xx, yy, way_x, way_y) {
			const cell = this._options.cell;
			const map = this._data;
			const xRange = way_x === 0 ? [xx - 10, xx + cell.cols + 10] : way_x < 0 ? [xx - 20, xx + cell.cols] : [xx, xx + cell.cols + 20];
			const yRange = way_y === 0 ? [yy - 10, yy + cell.rows + 10] : way_y < 0 ? [yy - 20, yy + cell.rows] : [yy, yy + cell.rows + 20];
			
			for (let x = xRange[0]; x <= xRange[1]; x++) {
				for (let y = yRange[0]; y <= yRange[1]; y++) {
					if (!map[x]?.[y]) return void this._load_map({ x1: xRange[0], x2: xRange[1], y1: yRange[0], y2: yRange[1] });
				}
			}
		}
		
		_render(buffer, buffer2, mouse) {
			this._checkMoveMap(mouse);
			
			if (this._rebuild_buffer) {
				// Перестраиваем буфер
				this._rebuild_buffer = false;
				this._rebuild_buffer2 = false;
				this._rebuildBuffer(buffer);
				this._rebuildBuffer2(buffer2);
			} else if (this._rebuild_buffer2) {
				this._rebuild_buffer2 = false;
				this._rebuildBuffer2(buffer2);
			}
			
			return this._options.pos.offset;
		}
	};
	
	static Resources = class {
		static _store = {};
		static _loading = {};
		
		static add(url, callback) {
			if (typeof url === 'object') {
				for (const v of Object.values(url)) {
					this.add(v, callback || false);
				}
				return;
			}
			
			if (this._store[url]) {
				callback?.();
				return;
			}
			
			if (!this._loading[url]) {
				const image = new Image();
				image.onload = () => {
					this._loading[url].forEach(cb => {
						if (typeof cb === 'function') cb();
					});
					delete this._loading[url];
				};
				
				image.src = url;
				this._store[url] = image;
				this._loading[url] = [callback || false];
			} else if (callback) {
				this._loading[url].push(callback);
			}
		}
		
		static get(url) {
			return this._store[url] || null;
		}
		
		static has(url) {
			return !!this._store[url];
		}
	};
	
	static Sprite = class {
		constructor(url, pos, size, speed, frames, dir = 'horizontal', once) {
			this.url = url;
			this.pos = pos;
			this.size = size;
			this.speed = typeof speed === 'number' ? speed : 0;
			this.frames = frames;
			this._index = 0;
			this.dir = dir;
			this.once = once;
			this.done = false;
		}
		
		update(dt) {
			this._index += this.speed * dt;
		}
		
		render(ctx) {
			let frame;
			
			if (this.speed > 0) {
				const max = this.frames.length;
				const idx = Math.floor(this._index);
				frame = this.frames[idx % max];
				
				if (this.once && idx >= max) {
					this.done = true;
					return;
				}
			} else {
				frame = 0;
			}
			
			let [x, y] = this.pos;
			
			if (this.dir === 'vertical') {
				y += frame * this.size[1];
			} else {
				x += frame * this.size[0];
			}
			
			const img = WorldMap.Resources.get(this.url);
			if (!img) return;
			
			ctx.drawImage(
				img,
				x, y,
				this.size[0], this.size[1],
				0, 0,
				this.size[0], this.size[1]
			);
		}
	};
};
